import merge from 'lodash/merge'
import baseTheme from 'gatsby-theme-marketplace-base/src/theme/index'

const theme = merge({}, baseTheme, {
  fontFamily:
    "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  font: {
    bold: 600,
  },
  header: {
    height: '52px',
  },
})

export default theme
